const items = document.querySelectorAll('.faq-item');

items.forEach((item) => {
  const btn = item.querySelector('.faq-btn');
  const body = item.querySelector('.faq-body');

  btn.addEventListener('click', () => {
    const isOpen = item.classList.contains('open');

    // Close all
    items.forEach((i) => {
      i.classList.remove('open');
      i.querySelector('.faq-body').style.maxHeight = '0';
      i.querySelector('.faq-btn').setAttribute('aria-expanded', 'false');
    });

    // Open clicked if it was closed
    if (!isOpen) {
      item.classList.add('open');
      body.style.maxHeight = body.scrollHeight + 'px';
      btn.setAttribute('aria-expanded', 'true');
    }
  });
});

// Open first item by default
const first = items[0];
const firstBody = first.querySelector('.faq-body');
first.classList.add('open');
firstBody.style.maxHeight = firstBody.scrollHeight + 'px';
first.querySelector('.faq-btn').setAttribute('aria-expanded', 'true');
